/* Progressive article navigation: never hides article content or requires a service. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.bkReady) return;
    root.dataset.bkReady = 'true';
    const prose = root.querySelector('[data-bk-prose]');
    const aside = root.querySelector('.bk-article-outline');
    if (!prose || !aside) return;
    const details = aside.querySelector('details');
    const list = aside.querySelector('ol');
    const desktop = window.matchMedia('(min-width: 1100px)');
    const outlineLevel = prose.querySelector('h2:not([data-bk-toc-skip])') ? 'h2:not([data-bk-toc-skip])' : 'h3';
    const headingNodes = [...prose.querySelectorAll(outlineLevel)].filter(h => h.textContent.trim() && !h.closest('aside,nav,[data-bk-toc-exclude]'));
    const ids = new Set([...document.querySelectorAll('[id]')].map(el => el.id));
    const headings = [];
    headingNodes.forEach((heading, index) => {
      // Preserve authored anchors. Index-based generated anchors survive translated labels.
      if (!heading.id || document.getElementById(heading.id) !== heading) {
        let id = `bk-section-${index + 1}`;
        let suffix = 2;
        while (ids.has(id)) id = `bk-section-${index + 1}-${suffix++}`;
        heading.id = id;
        ids.add(id);
      }
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      li.append(link);
      list.append(li);
      headings.push({heading, link});
    });
    prose.querySelectorAll('table').forEach(table => {
      if (table.closest('.bk-table-scroll')) return;
      const wrap = document.createElement('div');
      wrap.className = 'bk-table-scroll';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', root.dataset.tableLabel || 'Comparison table');
      table.before(wrap);
      wrap.append(table);
    });
    if (!headings.length) return;
    aside.hidden = false;
    const syncViewport = () => { details.open = desktop.matches; };
    syncViewport();
    desktop.addEventListener('change', syncViewport);
    details.addEventListener('toggle', () => { if (desktop.matches && !details.open) details.open = true; });
    let offset = 24;
    let scheduled = false;
    function update() {
      scheduled = false;
      // Only visible fixed/sticky header geometry contributes to the jump offset.
      let bottom = 0;
      document.querySelectorAll('#sticky-header,.sticky-header,.header-sticky').forEach(el => {
        const box = el.getBoundingClientRect();
        const position = getComputedStyle(el).position;
        if ((position === 'fixed' || position === 'sticky' || el.classList.contains('sticky')) && box.top <= 1 && box.bottom > 0 && box.height < innerHeight / 2) bottom = Math.max(bottom, box.bottom);
      });
      const header = document.querySelector('#page-header');
      const sticky = document.querySelector('#sticky-header');
      const enabled = header?.dataset.sticky === 'true' && (innerWidth >= 1025 || header?.dataset.stickyMobile === 'true');
      if (enabled && sticky) {
        const height = sticky.getBoundingClientRect().height;
        if (height < innerHeight / 2) bottom = Math.max(bottom, height);
      }
      offset = bottom + 16;
      root.style.setProperty('--bk-header-offset', `${offset}px`);
      const tocHeight = !desktop.matches ? aside.querySelector('summary').getBoundingClientRect().height + 16 : 0;
      let current = headings[0];
      for (const entry of headings) {
        if (entry.heading.getBoundingClientRect().top <= offset + tocHeight + 40) current = entry;
      }
      for (const entry of headings) {
        if (entry === current) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      }
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
    function targetFromHash() {
      try { const id = decodeURIComponent(location.hash.slice(1)); return headings.find(entry => entry.heading.id === id); } catch { return null; }
    }
    function jump(entry, focus) {
      if (!desktop.matches) details.open = false;
      update();
      const tocHeight = !desktop.matches ? aside.querySelector('summary').getBoundingClientRect().height + 16 : 0;
      if (focus) {
        if (!entry.heading.hasAttribute('tabindex')) {
          entry.heading.tabIndex = -1;
          entry.heading.addEventListener('blur', () => entry.heading.removeAttribute('tabindex'), {once:true});
        }
        entry.heading.focus({preventScroll:true});
      }
      window.scrollTo({top:window.scrollY + entry.heading.getBoundingClientRect().top - offset - tocHeight - 16, behavior:'instant'});
      schedule();
    }
    list.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const entry = headings.find(item => item.link === link);
      if (!entry) return;
      event.preventDefault();
      history.pushState(null, '', link.hash);
      jump(entry, true);
    });
    const followHash = () => { const entry = targetFromHash(); if (entry) requestAnimationFrame(() => jump(entry, false)); };
    window.addEventListener('hashchange', followHash);
    window.addEventListener('popstate', followHash);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', followHash, {once:true});
    update();
    followHash();
    // Translation runtimes may update text after load; refresh labels without rebuilding IDs.
    const observer = new MutationObserver(() => {
      for (const entry of headings) {
        const text = entry.heading.textContent.trim();
        if (entry.link.textContent !== text) entry.link.textContent = text;
      }
    });
    for (const entry of headings) observer.observe(entry.heading, {childList:true,subtree:true,characterData:true});
  }
  function start() { document.querySelectorAll('[data-bk-article]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
